
// customElements.get("sticky-add-to-cart") || customElements.define("sticky-add-to-cart", StickyAddToCartComponent);

import { Component } from "@theme/component";
import { ThemeEvents, QuantitySelectorUpdateEvent } from "@theme/events";
import { morph } from "@theme/morph";
import { onAnimationEnd } from "@theme/utilities";

const BOGOS_SELECTOR =
    '.bogos-volume-discount-widget-footer, .bogos-bundles-widget-footer, [class*="bogos"][class*="widget-footer"]';

class StickyAddToCartComponent extends Component {
    requiredRefs = ["stickyBar", "addToCartButton", "quantityDisplay", "quantityNumber"];
    #t = null;
    #e = null;
    #n;
    #i = !1;
    #a = null;
    #r = new AbortController();
    #s = null;
    #o = 1;
    #d = !0;
    #c = !1;
    #j = null;
    connectedCallback() {
        super.connectedCallback(), this.#l(), this.#u(), this.#h();
        const { signal: t } = this.#r,
            e = this.closest(".shopify-section");
        e?.addEventListener(ThemeEvents.variantUpdate, this.#y, { signal: t }),
            e?.addEventListener(ThemeEvents.variantSelected, this.#p, { signal: t }),
            e?.addEventListener("nk:variant-change", this.#m, { signal: t }),
            document.addEventListener(ThemeEvents.cartUpdate, this.#b, { signal: t }),
            document.addEventListener(ThemeEvents.cartError, this.#b, { signal: t }),
            document.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#f, { signal: t }),
            this.#k();
    }
    disconnectedCallback() {
        super.disconnectedCallback(),
            this.#t?.disconnect(),
            this.#e?.disconnect(),
            this.#j?.disconnect(),
            (this.#j = null),
            this.#r.abort(),
            this.#a && clearTimeout(this.#a);
    }
    #l() {
        const t = this.#v();
        if (!t) return;
        this.#s = t.querySelector('[ref="addToCartButton"]');
        const e = document.querySelectorAll('footer, [class*="footer-group"]'),
            n = e.length ? e[e.length - 1] : null;
        n &&
            ((this.#e = new IntersectionObserver(
                (t) => {
                    const [e] = t;
                    e && ((this.#c = e.isIntersecting), this.#g());
                },
                { rootMargin: "0px 0px 0px 0px" }
            )),
            this.#e.observe(n)),
            this.#x(),
            this.#g();
    }
    #x() {
        this.#t?.disconnect(), (this.#t = null);
        const t = document.querySelector(BOGOS_SELECTOR);
        t || this.#z();
        const e = t || this.#s || this.#v();
        if (!e) return;
        (this.#t = new IntersectionObserver(
            (t) => {
                const [e] = t;
                e && ((this.#d = e.isIntersecting || e.boundingClientRect.top > 0), this.#g());
            },
            { threshold: 0, rootMargin: "0px 0px 0px 0px" }
        )),
            this.#t.observe(e);
    }
    #z() {
        if (this.#j) return;
        (this.#j = new MutationObserver(() => {
            document.querySelector(BOGOS_SELECTOR) && (this.#j.disconnect(), (this.#j = null), this.#x());
        })),
            this.#j.observe(document.body, { childList: !0, subtree: !0 });
    }
    #g() {
        const t = !this.#d && !this.#c;
        t && !this.#i ? this.#C() : !t && this.#i && this.#S();
    }
    handleToggleClick = () => {
        const { stickyBar: t } = this.refs,
            e = !("true" === t.dataset.collapsed);
        (t.dataset.collapsed = e ? "true" : "false"), this.#T(!e);
    };
    #h() {
        const t = this.#v();
        if (!t) return;
        const e = t.querySelectorAll('nk-variant-picker input[type="radio"]:checked'),
            n = new Map();
        e.forEach((t) => {
            const e = t.dataset.optionIndex;
            null != e && n.set(e, t.dataset.optionValue || t.value);
        }),
            this.querySelectorAll("[data-sticky-option]").forEach((t) => {
                const e = t.dataset.optionIndex,
                    i = t.dataset.optionValue,
                    a = n.get(e) === i;
                t.classList.toggle("is-active", a), t.setAttribute("aria-pressed", a ? "true" : "false");
            });
    }
    #u() {
        const { signal: t } = this.#r;
        this.querySelectorAll("[data-sticky-option]").forEach((e) => {
            e.addEventListener("click", this.#B, { signal: t });
        }),
            this.querySelectorAll("[data-sticky-qty]").forEach((e) => {
                e.addEventListener("click", this.#A, { signal: t });
            });
    }
    #B = (t) => {
        const e = t.currentTarget;
        if (e.disabled) return;
        const n = this.#v();
        if (!n) return;
        const i = e.dataset.optionIndex,
            a = e.dataset.optionValue,
            r = Array.from(n.querySelectorAll(`nk-variant-picker input[type="radio"][data-option-index="${i}"]`)).find(
                (t) => (t.dataset.optionValue || t.value) === a
            );
        r instanceof HTMLInputElement &&
            !r.disabled &&
            ((r.checked = !0), r.dispatchEvent(new Event("change", { bubbles: !0 })), this.#h());
    };
    #A = (t) => {
        const e = t.currentTarget.dataset.stickyQty,
            n = this.#q();
        if (!n) return;
        const i = "plus" === e ? n.querySelector('[ref="plusButton"]') : n.querySelector('[ref="minusButton"]');
        i instanceof HTMLButtonElement && !i.disabled && i.click();
    };
    #E() {
        this.#o = 1;
        const t = this.#q(),
            e = t?.querySelector('[ref="quantityInput"]');
        e instanceof HTMLInputElement &&
            "1" !== e.value &&
            ((e.value = "1"),
            e.dispatchEvent(new Event("input", { bubbles: !0 })),
            e.dispatchEvent(new Event("change", { bubbles: !0 })),
            e.dispatchEvent(new Event("blur", { bubbles: !0 })));
        const n = this.refs.stickyQtyDisplay;
        n && (n.textContent = "1"), this.#I();
    }
    #T(t) {
        const e = this.refs.toggleButton;
        e &&
            (e.setAttribute("aria-expanded", t ? "true" : "false"),
            e.setAttribute("aria-label", t ? "Collapse add to cart options" : "Expand add to cart options"));
    }
    handleAddToCartClick = () => {
        this.#s &&
            ((this.#s.dataset.puppet = "true"),
            this.#s.click(),
            "true" !== this.refs.addToCartButton.dataset.added && (this.refs.addToCartButton.dataset.added = "true"),
            this.#n && clearTimeout(this.#n),
            (this.#n = setTimeout(() => {
                this.refs.addToCartButton.removeAttribute("data-added");
            }, 800)));
    };
    #y = (t) => {
        if (t.detail.data.productId !== this.dataset.productId) return;
        const e = t.detail.resource,
            n = t.detail.data.html.querySelector("sticky-add-to-cart");
        if (!n) return;
        const i = n.querySelector('[ref="stickyBar"]');
        if (!i) return;
        const a = this.refs.stickyBar.getAttribute("data-stuck") || "false",
            r = this.refs.stickyBar.getAttribute("data-collapsed") || "true",
            s = n.dataset.variantAvailable;
        morph(this.refs.stickyBar, i, { childrenOnly: !0 }),
            this.refs.stickyBar.setAttribute("data-stuck", a),
            this.refs.stickyBar.setAttribute("data-collapsed", r),
            (this.dataset.variantAvailable = s),
            this.#u(),
            this.#h(),
            this.#T("true" !== r),
            e && e.id && (this.dataset.currentVariantId = e.id);
        const o = this.#v();
        o && ((this.#s = o.querySelector('[ref="addToCartButton"]')), this.#x()),
            null == e && this.#Q(),
            requestAnimationFrame(() => this.#E());
    };
    #p = (t) => {
        const e = t.detail.resource?.id;
        e && (this.dataset.currentVariantId = e);
    };
    #m = () => {
        this.#h();
    };
    #Q = () => {
        this.dataset.currentVariantId = "";
        const t = this.querySelector(".sticky-add-to-cart__variant"),
            e = this.dataset.productId,
            n = document.querySelector(`variant-picker[data-product-id="${e}"]`);
        if (!t || !n) return;
        const i = Array.from(n.querySelectorAll("input:checked"))
            .map((t) => t.value)
            .filter((t) => "" !== t)
            .join(" / ");
        i && ((t.textContent = i), (t.hidden = !1));
    };
    #b = (t) => {
        this.#s && (this.#s.dataset.puppet = "false");
    };
    #f = (t) => {
        if (t.detail.cartLine) return;
        this.#o = t.detail.quantity;
        const e = this.refs.stickyQtyDisplay;
        e && (e.textContent = this.#o.toString()), this.#I();
    };
    #C() {
        const { stickyBar: t } = this.refs;
        (this.#i = !0), (t.dataset.stuck = "true");
    }
    #S() {
        const { stickyBar: t } = this.refs;
        (this.#i = !1), (t.dataset.stuck = "false");
    }
    #v() {
        const t = this.dataset.productId;
        if (!t) return null;
        const e = this.closest(".shopify-section");
        if (!e) return null;
        const n = e.id.replace("shopify-section-", "");
        return document.querySelector(`#shopify-section-${n} product-form-component[data-product-id="${t}"]`);
    }
    #q() {
        const t = this.#v();
        return t ? t.querySelector('quantity-selector-component[ref="quantitySelector"]') : null;
    }
    #k() {
        const t = this.#q(),
            e = t?.querySelector('[ref="quantityInput"]'),
            n = e ? parseInt(e.value, 10) : NaN;
        this.#o = Number.isFinite(n) ? n : parseInt(this.dataset.initialQuantity || "1", 10) || 1;
        const i = this.refs.stickyQtyDisplay;
        i && (i.textContent = this.#o.toString()), this.#I();
    }
    #I() {
        const { addToCartButton: t, quantityDisplay: e, quantityNumber: n } = this.refs;
        if ((n && (n.textContent = this.#o.toString()), e && (e.hidden = !0), !t)) return;
        const i = !t.disabled,
            a = t.querySelector("[data-nk-sticky-button-label]"),
            r = t.querySelector("[data-nk-sticky-action-label]"),
            s = t.querySelector("[data-nk-sticky-price-sep]"),
            o = t.querySelector('[ref="stickyButtonPrice"]');
        if (!a) return;
        if (!i)
            return void (a.textContent = t.disabled
                ? window.theme?.translations?.soldOut || "Sold out"
                : window.theme?.translations?.unavailable || "Unavailable");
        if (r && s && o)
            return (
                (r.textContent = window.theme?.translations?.addToCart || "Add to Cart"),
                (s.hidden = !1),
                void (o.hidden = !1)
            );
        const d = o?.textContent?.trim(),
            c = window.theme?.translations?.addToCart || "Add to Cart";
        a.innerHTML = d
            ? `<span data-nk-sticky-action-label>${c}</span><span data-nk-sticky-price-sep aria-hidden="true"> · </span><span ref="stickyButtonPrice" data-nk-sticky-price>${d}</span>`
            : c;
    }
}
customElements.get("sticky-add-to-cart") || customElements.define("sticky-add-to-cart", StickyAddToCartComponent);